import * as React from 'react'
import TextField from '@mulesoft/anypoint-components/lib/TextField'
import Select from '@mulesoft/anypoint-components/lib/Select'
import {
  areConditionFieldsEqual,
  BasicAlertConditionFields,
  BasicAlertConditionProps,
  basicAlertsEvaluationWindowOptions,
  basicAlertsOperators
} from '../../../../../../model'

export type Props = BasicAlertConditionProps & {
  metric: string
  unit?: string
}

type State = {
  fields: BasicAlertConditionFields
}

class BaseBasicAlertCondition extends React.PureComponent<Props, State> {

  constructor(props: Props) {
    super(props)

    this.onOperatorChange = this.onOperatorChange.bind(this)
    this.onThresholdChange = this.onThresholdChange.bind(this)
    this.onWindowChange = this.onWindowChange.bind(this)

    this.state = {fields: {...props.fields}}
  }

  onOperatorChange (e: { value: string }) {
    const fields = {...this.state.fields, operator: e.value}

    this.props.onChange(fields)
    this.setState({...this.state, fields})
  }

  onThresholdChange (e: { value: string }) {
    const threshold = this.props.getValidMinThreshold(this.state.fields.operator || 'above', e.value)
    const fields = {...this.state.fields, threshold: threshold}

    this.props.onChange(fields)
    this.setState({...this.state, fields})
  }

  onWindowChange (e: { value: string }) {
    const fields = {...this.state.fields, window: e.value}

    this.props.onChange(fields)
    this.setState({...this.state, fields})
  }

  getConditionLabel(value: string){
    const condition =  basicAlertsOperators.find(operator => operator.value === value)
    return  condition? condition.label.toLowerCase() : '';
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, prevContext: any) {
    const havePropsChanged = !areConditionFieldsEqual(prevProps.fields, this.props.fields)

    if (havePropsChanged) {
      this.setState({...this.state, fields: {...this.props.fields}})
    }
  }

  render () {
    const {metric, unit} = this.props
    const {fields} = this.state
    const metricVerb = metric === 'number of occurrences' ? 'are' : 'is'
    const alertConditionMessage = `The alert will trigger when the ${metric} ${metricVerb}
                            ${this.getConditionLabel(fields.operator || 'above')}
                            ${fields.threshold}${unit || ''} for at least ${fields.window} consecutive periods of 1 minute.`

    return (
      <div className="base-basic-alert-condition">
        <div className={'basic-alert-modal-body-metric-input'}>
          <span>When {metric} {metricVerb} </span>
          <Select
            testId={'basic-alert-modal-body-metric-operator-select'}
            options={basicAlertsOperators}
            value={fields.operator}
            onChange={this.onOperatorChange}
            disabled={!!fields.editDisabled}
          />
          <TextField
            testId={'basic-alert-modal-body-metric-threshold-value'}
            type={'number'}
            value={fields.threshold}
            onChange={this.onThresholdChange}
            disabled={!!fields.editDisabled}
          />
          {unit && <span className={'basic-alert-modal-body-metric-input-unit'}>{unit}</span>}
        </div>
        <div className={'basic-alert-modal-body-metric-input'}>
          <span>For at least</span>
          <Select
            testId={'basic-alert-modal-body-metric-minutes'}
            options={basicAlertsEvaluationWindowOptions}
            value={fields.window}
            onChange={this.onWindowChange}
            disabled={!!fields.editDisabled}
          />
          <span>minutes.</span>
        </div>
        <div className={'basic-alert-modal-body-metric-message'}>
          <header className={'basic-alert-modal-body-metric-message-title'} > Preview </header>
          <section className={'basic-alert-modal-body-metric-message-body'}>
            {alertConditionMessage}
          </section>
        </div>
      </div>
    )
  }
}

export default BaseBasicAlertCondition
